// source: pushwoosh/api_tokens/api_tokens.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderBy', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderDirection', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.Restrictions', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.api_tokens.Restrictions.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.Restrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.Restrictions.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.Restrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.displayName = 'proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageApplicationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    messageGroupsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    modifyAccount: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    modifyApplication: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    modifyMessage: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    modifyTag: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.Restrictions;
  return proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addMessageApplications(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMessageGroups(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setModifyAccount(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setModifyApplication(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setModifyMessage(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setModifyTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageApplicationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getMessageGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getModifyAccount();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getModifyApplication();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getModifyMessage();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getModifyTag();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * repeated string message_applications = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.getMessageApplicationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.setMessageApplicationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.addMessageApplications = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.clearMessageApplicationsList = function() {
  return this.setMessageApplicationsList([]);
};


/**
 * repeated string message_groups = 2;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.getMessageGroupsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.setMessageGroupsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.addMessageGroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.clearMessageGroupsList = function() {
  return this.setMessageGroupsList([]);
};


/**
 * optional bool modify_account = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.getModifyAccount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.setModifyAccount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool modify_application = 4;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.getModifyApplication = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.setModifyApplication = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool modify_message = 5;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.getModifyMessage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.setModifyMessage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool modify_tag = 6;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.getModifyTag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.Restrictions} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.Restrictions.prototype.setModifyTag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    restrictions: (f = msg.getRestrictions()) && proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest;
  return proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.Restrictions;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Restrictions restrictions = 2;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.getRestrictions = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.Restrictions, 2));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenRequest.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    restrictions: (f = msg.getRestrictions()) && proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse;
  return proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.Restrictions;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Restrictions restrictions = 4;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.getRestrictions = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.Restrictions, 4));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.CreateApiTokenResponse.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest;
  return proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    restrictions: (f = msg.getRestrictions()) && proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse;
  return proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.Restrictions;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Restrictions restrictions = 4;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.getRestrictions = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.Restrictions, 4));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GetApiTokenResponse.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderBy: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderDirection: jspb.Message.getFieldWithDefault(msg, 3, 0),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    searchByName: (f = msg.getSearchByName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest;
  return proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderBy} */ (reader.readEnum());
      msg.setOrderBy(value);
      break;
    case 3:
      var value = /** @type {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderDirection} */ (reader.readEnum());
      msg.setOrderDirection(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchByName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderBy();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOrderDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSearchByName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderBy = {
  NAME: 0,
  CREATED: 1
};

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderDirection = {
  ASC: 0,
  DESC: 1
};

/**
 * optional OrderBy order_by = 2;
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderBy}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.getOrderBy = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderBy} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional OrderDirection order_direction = 3;
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderDirection}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.getOrderDirection = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderDirection} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.OrderDirection} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.setOrderDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 per_page = 5;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue search_by_name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.getSearchByName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.setSearchByName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.clearSearchByName = function() {
  return this.setSearchByName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensRequest.prototype.hasSearchByName = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    apiTokensList: jspb.Message.toObjectList(msg.getApiTokensList(),
    proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.toObject, includeInstance),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse;
  return proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.deserializeBinaryFromReader);
      msg.addApiTokens(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken;
  return proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ApiToken api_tokens = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken>}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.getApiTokensList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken>} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.setApiTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.addApiTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.ApiToken, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.clearApiTokensList = function() {
  return this.setApiTokensList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.ListApiTokensResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    restrictions: (f = msg.getRestrictions()) && proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest;
  return proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.Restrictions;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Restrictions restrictions = 3;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.getRestrictions = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.Restrictions, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenRequest.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    restrictions: (f = msg.getRestrictions()) && proto.pushwoosh.rpc_v2.api_tokens.Restrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse;
  return proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.Restrictions;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.Restrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Restrictions restrictions = 4;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.getRestrictions = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.Restrictions, 4));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.Restrictions|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.UpdateApiTokenResponse.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest;
  return proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse;
  return proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.DeleteApiTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.KindCase = {
  KIND_NOT_SET: 0,
  MODIFY_ACCOUNT: 1,
  MODIFY_APPLICATION: 2,
  MODIFY_TAG: 3,
  MODIFY_MESSAGE: 4,
  MESSAGE_APPLICATIONS: 5,
  MESSAGE_GROUPS: 6
};

/**
 * @return {proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.KindCase}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    modifyAccount: (f = msg.getModifyAccount()) && proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.toObject(includeInstance, f),
    modifyApplication: (f = msg.getModifyApplication()) && proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.toObject(includeInstance, f),
    modifyTag: (f = msg.getModifyTag()) && proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.toObject(includeInstance, f),
    modifyMessage: (f = msg.getModifyMessage()) && proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.toObject(includeInstance, f),
    messageApplications: (f = msg.getMessageApplications()) && proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.toObject(includeInstance, f),
    messageGroups: (f = msg.getMessageGroups()) && proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.deserializeBinaryFromReader);
      msg.setModifyAccount(value);
      break;
    case 2:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.deserializeBinaryFromReader);
      msg.setModifyApplication(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.deserializeBinaryFromReader);
      msg.setModifyTag(value);
      break;
    case 4:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.deserializeBinaryFromReader);
      msg.setModifyMessage(value);
      break;
    case 5:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.deserializeBinaryFromReader);
      msg.setMessageApplications(value);
      break;
    case 6:
      var value = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.deserializeBinaryFromReader);
      msg.setMessageGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModifyAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.serializeBinaryToWriter
    );
  }
  f = message.getModifyApplication();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.serializeBinaryToWriter
    );
  }
  f = message.getModifyTag();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.serializeBinaryToWriter
    );
  }
  f = message.getModifyMessage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.serializeBinaryToWriter
    );
  }
  f = message.getMessageApplications();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.serializeBinaryToWriter
    );
  }
  f = message.getMessageGroups();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string application_code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.prototype.getApplicationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications.prototype.setApplicationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationGroupCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationGroupCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationGroupCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string application_group_code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.prototype.getApplicationGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups.prototype.setApplicationGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ModifyAccount modify_account = 1;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getModifyAccount = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyAccount|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.setModifyAccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.clearModifyAccount = function() {
  return this.setModifyAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.hasModifyAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ModifyApplication modify_application = 2;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getModifyApplication = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication, 2));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyApplication|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.setModifyApplication = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.clearModifyApplication = function() {
  return this.setModifyApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.hasModifyApplication = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ModifyTag modify_tag = 3;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getModifyTag = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyTag|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.setModifyTag = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.clearModifyTag = function() {
  return this.setModifyTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.hasModifyTag = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ModifyMessage modify_message = 4;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getModifyMessage = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage, 4));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.ModifyMessage|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.setModifyMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.clearModifyMessage = function() {
  return this.setModifyMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.hasModifyMessage = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MessageApplications message_applications = 5;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getMessageApplications = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications, 5));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageApplications|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.setMessageApplications = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.clearMessageApplications = function() {
  return this.setMessageApplications(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.hasMessageApplications = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MessageGroups message_groups = 6;
 * @return {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.getMessageGroups = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups, 6));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.MessageGroups|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
*/
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.setMessageGroups = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.clearMessageGroups = function() {
  return this.setMessageGroups(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationRequest.prototype.hasMessageGroups = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse;
  return proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.api_tokens.GrantRightOnApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.api_tokens);
